/**
 * Телефон у читабельному вигляді.
 *
 * У базі номери лежать самими цифрами — так їх нормалізує бекенд, щоб той
 * самий номер у різних написаннях був одним записом. Показувати
 * `380442345678` користувачеві незручно, тож формат накладаємо на рендері:
 * це справа інтерфейсу, а не сховища.
 *
 * Український номер розбивається на `+38 (0XX) XXX-XX-XX`, іноземний
 * лишається як є: вгадувати чужі формати гірше, ніж показати цифри.
 */
export const formatPhone = (phone: string): string => {
    if (/^380\d{9}$/.test(phone)) {
        return `+38 (${phone.slice(2, 5)}) ${phone.slice(5, 8)}-${phone.slice(8, 10)}-${phone.slice(10)}`
    }

    return phone
}

/** Кілька номерів через кому — для колонок таблиці. */
export const formatPhones = (phones: readonly string[] | null | undefined): string =>
    (phones ?? []).map(formatPhone).join(', ')
